import React from 'react'
import styles from './style.module.scss'
import ArticleBigOlympics from '../common/articleBigOlympics'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

const TrendingNewsContent = dynamic(() => import('../olympicsTrendingNews/trendingNewsContent'))

export default function LatestArticles({ data, mainArticle }) {
  // const { data, loading } = useQuery(TRENDING_NEWS, {
  //   variables: { input: { nSkip: 0, nLimit: 4 } }
  // })
  return (
    <>
      {data && data?.length > 0 && (
        <div className={styles.leaguePointsTable}>
          {/* <h3 className="small-head d-flex align-items-center mb-2">
            Latest Articles
          </h3> */}
          <div className="widget-title d-flex justify-content-between align-items-center">
            <h3 className="small-head d-flex align-items-center mb-0 fw-bold">
              Latest Articles
            </h3>
          </div>
          <div>
            <ArticleBigOlympics article={mainArticle || data[0]} />
            <div className="trendingList">
                <TrendingNewsContent
                  data={data}
                  imgCol={2}
                />
            </div>
          </div>
        </div>
      )}
    </>
  )
}
LatestArticles.propTypes = {
  data: PropTypes.any,
  mainArticle: PropTypes.object
}
